// Definizioni delle azioni assistenziali (D12) condivise tra pannello operatore
// e diario assistenziale. SOLO etichette/campi UI: nessuna logica clinica.

export const ACTION_DEFS = [
  {
    type: "room_cleaning",
    label: "Pulizia stanza",
    icon: "fa-solid fa-broom",
    statuses: ["completed", "not_done"],
  },
  {
    type: "morning_hygiene",
    label: "Igiene mattutina",
    icon: "fa-solid fa-hands-bubbles",
    statuses: ["completed", "not_done"],
  },
  {
    type: "shower",
    label: "Doccia",
    icon: "fa-solid fa-shower",
    statuses: ["completed", "not_done"],
  },
  {
    type: "diaper_change",
    label: "Cambio panno",
    icon: "fa-solid fa-toilet-paper",
    supply: true,
    statuses: ["completed", "not_done", "to_verify"],
  },
  {
    type: "meal_administration",
    label: "Pasto",
    icon: "fa-solid fa-utensils",
    meal: true,
    statuses: ["completed", "partial", "refused", "skipped"],
  },
  {
    type: "medication_administration",
    label: "Farmaco",
    icon: "fa-solid fa-pills",
    therapy: true,
    statuses: ["completed", "not_done", "refused", "to_verify"],
  },
  {
    type: "blood_glucose",
    label: "Glicemia",
    icon: "fa-solid fa-droplet",
    vital: true,
    moment: true,
    fields: [{ key: "numericValue", label: "Glicemia (mg/dL)" }],
  },
  {
    type: "blood_pressure",
    label: "Pressione",
    icon: "fa-solid fa-heart-pulse",
    vital: true,
    fields: [
      { key: "numericValue", label: "Sistolica" },
      { key: "numericValue2", label: "Diastolica" },
      {
        key: "numericValue3",
        label: "Frequenza cardiaca (opz.)",
        optional: true,
      },
    ],
  },
  {
    type: "oxygen_saturation",
    label: "Saturazione",
    icon: "fa-solid fa-lungs",
    vital: true,
    oxygen: true,
    fields: [
      { key: "numericValue", label: "SpO2 (%)" },
      {
        key: "numericValue2",
        label: "Frequenza cardiaca (opz.)",
        optional: true,
      },
    ],
  },
];

export const STATUS_LABELS = {
  completed: "Completata",
  partial: "Parziale",
  refused: "Rifiutata",
  skipped: "Saltata",
  not_done: "Non effettuata",
  to_verify: "Da verificare",
};

export const MEAL_LABELS = {
  breakfast: "Colazione",
  lunch: "Pranzo",
  dinner: "Cena",
  snack: "Merenda",
  other: "Altro",
};

export const MEASUREMENT_MOMENTS = {
  fasting: "Digiuno",
  pre_lunch: "Pre-pranzo",
  post_lunch: "Post-pranzo",
  pre_dinner: "Pre-cena",
  post_dinner: "Post-cena",
  night: "Notte",
  other: "Altro",
};

export const actionDef = (type) => ACTION_DEFS.find((a) => a.type === type);
export const actionLabel = (type) => actionDef(type)?.label || type;
export const statusLabel = (s) => STATUS_LABELS[s] || s;

// Stringa leggibile dei valori rilevati per il diario.
export const formatActivityValue = (a) => {
  if (!a) return "";
  switch (a.actionType) {
    case "blood_glucose": {
      const moment = a.metadata?.measurementMoment
        ? ` (${
            MEASUREMENT_MOMENTS[a.metadata.measurementMoment] ||
            a.metadata.measurementMoment
          })`
        : "";
      return a.numericValue != null
        ? `${a.numericValue} ${a.unit || "mg/dL"}${moment}`
        : "";
    }
    case "blood_pressure": {
      if (a.numericValue == null) return "";
      const fc = a.numericValue3 != null ? ` · fc ${a.numericValue3}` : "";
      return `${a.numericValue}/${a.numericValue2} ${a.unit || "mmHg"}${fc}`;
    }
    case "oxygen_saturation": {
      if (a.numericValue == null) return "";
      const fc = a.numericValue2 != null ? ` · fc ${a.numericValue2}` : "";
      const o2 = a.metadata?.oxygen ? " · O₂" : "";
      return `${a.numericValue}${a.unit || "%"}${fc}${o2}`;
    }
    case "meal_administration":
      return MEAL_LABELS[a.mealType] || a.mealType || "";
    case "medication_administration":
      return a.actionLabel || "";
    default:
      return "";
  }
};
